import React from 'react';

// Wraps every match of the search terms (supporting `|` OR and `&` AND separators)
// in a highlighted <span>. Non-string children pass through untouched.
export function highlightMatch(text, searchText) {
  if (!searchText) return text;

  const terms = searchText
    .split('|')
    .flatMap((t) => t.split('&'))
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);

  if (!terms.length) return text;

  let parts = [text];
  terms.forEach((term) => {
    const next = [];
    parts.forEach((part) => {
      if (typeof part !== 'string') { next.push(part); return; }
      const regex = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      const pieces = part.split(regex);
      pieces.forEach((s, i) => {
        if (i % 2 === 1) {
          next.push(
            <span key={`${term}-${i}-${s}`} style={{ backgroundColor: 'yellow' }}>{s}</span>
          );
        } else {
          next.push(s);
        }
      });
    });
    parts = next;
  });
  return parts;
}
